import React, { useState } from "react";

// Components
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./WYSIWYG.scss";

const WYSIWYGEditor = React.forwardRef((props, ref) => {
  const { defaultEditorContent, toolbar, onChange } = props;
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const text = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    onChange(text.trim() === "<p></p>" ? "" : text);
  };

  React.useEffect(() => {
    setEditorState(EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(defaultEditorContent)
      )
    ))
  },[]);

  return (
    <React.Fragment>
      <div className="editor">
        <Editor
          editorState={editorState}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          onEditorStateChange={onEditorStateChange}
          toolbar={toolbar}
          ref={ref}
        />
      </div>
    </React.Fragment>
  );
});

export default WYSIWYGEditor;
